module.exports = {
  "earlyWarningManager": {
    "earlyWarningManager": "预警管理",
    "earlyWarning": "预警人员",
    "earlyWarningHint": "请输入预警人员姓名",
    "earlyWarningHint2": "请选择预警人员",
    "earlyWarningRank": "预警级别",
    "earlyWarningRankHint": "请选择预警级别",
    "earlyWarningList": "预警列表",
    "earlyWarningType": "预警类型",
    "earlyWarningTypeHint": "请输入预警类型",
    "earlyWarningTime": "预警时间",
    "earlyWarningSource": "预警来源",
    "earlyWarningSourceHint": "请选择预警来源",
    "deleteEvaluationHint": "删除该预警将不可恢复，确定吗？",
    "addEarlyWarning": "添加预警",
    "editEvalutaion": "编辑预警",
    "earlyWarningInfo": "预警信息",
    "earlyWarningRulesHint": "请完善预警规则",
    "earlyWarningRulesName": "规则名称",
    "earlyWarningRulesNameHint": "请输入预警规则名称",
    "correlationScale": "关联量表",
    "correlationScaleHint": "请选择关联量表",
    "deleteEvaluationRuleHint": "删除该预警规则 {0} 将不可恢复，确定吗？",
    "addEarlyWarningRules": "添加预警规则",
    "editEarlyWarningRules": "编辑预警规则",
    "ruleType": "规则类型",
    "ruleTypeHint": "请选择规则类型",
    "range": "总分",
    "grouping": "分组",
    "selectGrouping": "分组",
    "groupingHint": "请选择分组",
    "question": "题目",
    "selectQuestion": "选择题目",
    "questionHint": "请选择题目",
    "warningScope": "预警范围"
  },
};



// WEBPACK FOOTER //
// ./src/i18n/earlyWarningManager/en.js